import React from 'react';
import BlogPost from '../../components/Blog/BlogPost';
import BlogHeader from '../../components/Blog/BlogHeader';
import '../../styles/blog-overrides.scss';
import Footer from '../../components/Footer';

const BlogPostPage = () => {
  React.useEffect(() => {
    document.body.classList.add('blog-page');
    document.documentElement.classList.add('blog-page');
    return () => {
      document.body.classList.remove('blog-page');
      document.documentElement.classList.remove('blog-page');
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-dark">
      <BlogHeader />

      <div className="pt-24 sm:pt-28 lg:pt-32">
        <BlogPost />
      </div>
      <Footer />
    </div>
  );
};

export default BlogPostPage; 